import React, {useState} from 'react';
import {Provider, useDispatch, useSelector} from "react-redux";

import storeInit from "./storeInit";
import {isEmpty} from "lodash";
import useDidMountEffect from "./utils/useDidMountEffect";
import setAuthorizationHeader from "./utils/setAuthorizationHeader";
import apiUser from "./apiUser";
import appUserRoutes from "./appUserRoutes";

import {setUser} from "./reducers/user/actions";
import {setWorker} from "./reducers/worker/actions";
import {setVats} from "./reducers/vats/actions";
import {setWorkplaces} from "./reducers/workplaces/actions";
import {setWorkers} from "./reducers/workers/actions";
import {createWorkshop, setWorkshop} from "./reducers/workshop/actions";
import {setRepairOrderStatuses} from "./reducers/repairOrderStatuses/actions";
import {LoadingLayout} from "./App";
import {Redirect, Route, Switch} from "react-router-dom";
import SmsModalContainer from "./components/SmsModalContainer/SmsModalContainer";
import EmailModalContainer from "./components/EmailModalContainer/EmailModalContainer";
import {ToastContainer} from "react-toastify";
import SuppliersModal from "./components/Supplier/SuppliersModal/SuppliersModal";
import {setScreenBackground} from "./reducers/screenBackground/actions";
import {setJobCategories} from "./reducers/jobCategories/actions";
import {WebSocketProvider} from "./contexts/WebSocketContext";
import {setBsxPrinterAuths} from "./reducers/bsxPrinterAuths/actions";

const Login = React.lazy(() => import('./views/Login'));
const ResetPassword = React.lazy(() => import('./views/ResetPassword'));
const ResetPasswordConfirm = React.lazy(() => import('./views/ResetPasswordConfirm'));
const Register = React.lazy(() => import('./views/Register'));
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

const AppWorkshopInner = () => {
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()
  const {isUser, isWorker} = useSelector(state => ({
    isUser: !isEmpty(state?.user),
    isWorker: !isEmpty(state?.worker),
  }))

  useDidMountEffect(() => {
    if(localStorage.jwt){
      setAuthorizationHeader(localStorage.jwt)
      apiUser.login()
        .then(data => {
          dispatch(setUser(data?.user || {}));
          dispatch(setWorker(data?.worker || {}));
          dispatch(setScreenBackground((data?.user || data?.worker)?.screenBackground || {}));
          if(data.workshop){
            dispatch(setWorkshop(data.workshop))
            dispatch(setWorkers(data.workshop.workers));
            if(data?.user && !data.workshop.supplemented && window.location.pathname !== appUserRoutes.supplement){
              window.location = appUserRoutes.supplement;
            }
            dispatch(setVats(data.vats));
            dispatch(setWorkplaces(data.workplaces));
            dispatch(setRepairOrderStatuses(data.repairOrderStatuses));
            dispatch(setJobCategories(data.jobCategories));
            dispatch(setBsxPrinterAuths(data.bsxPrinterAuths));
          }else{
            dispatch(createWorkshop())
          }

          setLoading(false)
        }).catch(res => {
        switch (res?.response?.status) {
          case 401: {
            delete localStorage.jwt;
            setAuthorizationHeader(null);
            window.location.reload();

            break;
          }
        }
      })
    }else{
      setLoading(false)
    }
  })

  if(loading){
    return <LoadingLayout />
  }

  return <React.Fragment>
    <SmsModalContainer />
    <EmailModalContainer />
    <SuppliersModal />
    <Switch>
      <Route exact path={appUserRoutes.login} name="Zaloguj się" render={props => <Login {...props}/>} />
      <Route exact path={appUserRoutes.register} name="Załóż konto" render={props => <Register {...props}/>} />
      <Route exact path={appUserRoutes.resetPassword} name="Resetuj hasło" render={props => <ResetPassword {...props}/>} />
      <Route exact path={appUserRoutes.resetPasswordConfirm(':id')} name="Resetuj hasło" render={props => <ResetPasswordConfirm {...props}/>} />
      {(isUser || isWorker) && <Route path={appUserRoutes.home} name="Warsztat" render={props => <DefaultLayout {...props}/>}/>}

      <Redirect to={appUserRoutes.login} />
    </Switch>
  </React.Fragment>
}

const AppWorkshop = props => {
  return <Provider store={storeInit}>
    <WebSocketProvider>
      <ToastContainer position="bottom-right" autoClose={5000} />
      <AppWorkshopInner {...props} />
    </WebSocketProvider>
  </Provider>
};

AppWorkshop.propTypes = {

};

export default AppWorkshop;